import { api } from './api'

function loadScript() {
  if (window.Razorpay) return Promise.resolve(true)
  return new Promise(resolve => {
    const s = document.createElement('script')
    s.src = 'https://checkout.razorpay.com/v1/checkout.js'
    s.onload = () => resolve(true)
    s.onerror = () => resolve(false)
    document.body.appendChild(s)
  })
}

const wait = ms => new Promise(r => setTimeout(r, ms))

// After payment, ask our server to confirm it. Retry on network / server errors (the money is already taken).
async function verify(r) {
  let last
  for (let attempt = 0; attempt < 3; attempt++) {
    try { return await api.verifyPayment(r) } catch (err) {
      last = err
      if (err.status && err.status < 500) break // a clear "no" from the server, do not retry
      await wait(1500)
    }
  }
  throw last
}

// 1) our server prices the cart, creates the Razorpay order and saves the order as pending
// 2) the Razorpay popup opens  3) on payment we confirm it with the server
// onSuccess({ paymentId, orderNo, confirmed })
export async function payWithRazorpay({ checkout, notes, onSuccess, onFailure }) {
  try {
    if (!(await loadScript())) return onFailure('Could not load Razorpay. Check your internet and try again.')
    const o = await api.createPaymentOrder(checkout)
    const rz = new window.Razorpay({
      key: o.key_id,
      order_id: o.order_id,
      amount: o.amount,
      currency: o.currency,
      name: 'iPOINT',
      description: `Order ${o.order_no}`,
      prefill: { name: checkout.name, email: checkout.email, contact: checkout.phone },
      notes,
      theme: { color: '#1f4fd8' },
      handler: async r => {
        try {
          const v = await verify(r)
          onSuccess({ paymentId: r.razorpay_payment_id, orderNo: v?.order_no || o.order_no, confirmed: true })
        } catch (err) {
          console.error('[iPOINT] Paid but could not confirm the order:', err, r)
          onSuccess({ paymentId: r.razorpay_payment_id, orderNo: o.order_no, confirmed: false })
        }
      },
      modal: { ondismiss: () => onFailure('Payment cancelled.') },
    })
    rz.on('payment.failed', r => onFailure(r.error?.description || 'Payment failed. Please try again.'))
    rz.open()
  } catch (err) {
    onFailure(err.message || 'Could not start the payment. Please try again.')
  }
}